// extracted by mini-css-extract-plugin
export default {"wrapper":"Sidebar_wrapper__VpgFJ","menu":"Sidebar_menu__2Y-Q0","menu_item":"Sidebar_menu_item__OyjfE","active":"Sidebar_active__rH+Se"};